import React from 'react';
import {
  AudienceSection,
  ContactSection,
  FAQSection,
  FellowshipBanner,
  FellowshipStructure,
  FinalCTASection,
  KeyBenefitsSection,
  ProblemSection,
  UniqueSection
} from '../../sections';

const FellowshipPage = () => {
  return (
    <>
      <FellowshipBanner />
      <ProblemSection />
      <AudienceSection />
      <FellowshipStructure />
      <KeyBenefitsSection />
      <UniqueSection />
      {/* <SampleProjects />
      <JourneyDiagram />
      <TestimonialsSection /> */}
      <FinalCTASection />
      <ContactSection />
      <FAQSection />
    </>
  );
};

export default FellowshipPage;
